import type { Board } from "../board";
import { LevelGeneratorScrewUp } from "./levelGeneratorScrewUp";

export type LevelAcceptanceCriteria = (board: Board) => boolean;

export function generateWithRetries(
	levelNumber: number,
	attempt: () => Board,
	accept?: LevelAcceptanceCriteria,
): Board {
	const maxAttempts = 1000;
	const startTime = Date.now();

	for (let attemptNumber = 1; attemptNumber <= maxAttempts; attemptNumber++) {
		try {
			const board = attempt();
			if (accept && !accept(board)) {
				throw new LevelGeneratorScrewUp("QA: caller criteria rejected candidate");
			}
			const elapsed = Date.now() - startTime;
			console.log(
				`Level ${levelNumber} generated in ${elapsed}ms (${attemptNumber} attempt${attemptNumber > 1 ? "s" : ""})`,
			);
			return board;
		} catch (e) {
			if (!(e instanceof LevelGeneratorScrewUp)) throw e;
			if (attemptNumber === 100) {
				console.warn(`Level ${levelNumber}: 100 generation attempts failed, still retrying...`);
			}
		}
	}

	throw new Error(`Level ${levelNumber}: generation failed after ${maxAttempts} attempts`);
}
